import { isFieldGroup } from '@modusign/react-signing';
import { FieldNode } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

import { hasPosition } from '@app/features/apply-react-signing/libs/fieldTypeGuards';

export function getPageInField(field: DeepReadonly<FieldNode> | FieldNode) {
  if (isFieldGroup(field)) {
    return field.pages[0];
  }
  if (hasPosition(field)) {
    return field.position.page;
  }

  if (process.env.REACT_APP_MODUSIGN_ENV !== 'production') {
    throw new Error('UNIMPLEMENTED');
  }
  return 1;
}
